export const wrhLangEn = {
         ticketWrh: {
           storeName: "convenience Store name",
           selectStore: "pls choose convenience Store name",
           waitApproval: "Waiting for approval",
           alApproval: "Approval completed",
           look: "look", //翻译
           approvalComments: "Relevant approval opinions",
           currentApproval: "Validador",
           time: "time",
           approvalPeople: "Auditor",
           approvalComment: "Approval comments",
           waitOrder: "Pending",
           orderstatus: "Order status",
           loanamount: "Loan amount",
           partiallyCompleted: "Partially completed",
           normalStatus: "Normal",
           noNormalStatus: "abnormal",
           userName: "User name",
           orderInvalidTime: "Order expiration time",
           dial: "Dial",
           Submit: "Submit",
           IsGP0: "non-F2F",
           IsGP1: "F2F",
           showNumber: "Number",
           To: 'To'
         },
         tipsWrh: {
           calcFee: "Calculate service fee",
           calcFeeTip:
             "（Attention：Enter the repayment amount and click calculate service fee to display service fee and service fee IVA）",
           fee: "fee",
           feeIVA: "IVA fee",
           currentPersonalTime:
             "Current number of personal remaining deductions",
           currentGroupTime: "Current group remaining deductions",
           currentRemainingDeduction: "The current remaining individuals can apply for the total amount of reduction and exemption",
           makeLoan: "Make Loans",
           continueFollow: "Continue to follow up",
           userBirthday: "User's date of birth",
           enterUserBirthday: "Please fill in the date of birth",
           opreSuccess: "Operation successful",
           enterMark: "	Other（Remarks）",
           userAndOrder: "User & order information",
           diaOperation: "Dial operation",
           productInfo: "Product information",
           product: "Product",
           pleaseResult: "Please select a result",
           previewImage: "I'm a picture click to preview",
           selectBrithday: "Please select birthday date",
           enterTelephone: "please input your phone number",
           enterIdCard: "please enter Id number",
           enterCurp: "please enter CURP",
           enterStaffNum: "please enter the employee number",
           enterChilNum: "please enter the number of children",
           enterFamilyAddress: "please enter your home address",
           enterPhone: "please input your phone number",
           enterCompanyName: "please enter company name",
           enterCompanyPosition: "please enter job title",
           enterCompanyTime: "please enter production time",
           enterRewardMoney: "please enter amount",
           editPeople: "edit Personnel Information",
           addPeople: "added information about people",
           enterRFC: "please enter RFC",
           noNormal: "informal",
           admin: "Admin",
           editBaseInfo: "edit your profile",
           enterStatus: "please select the current status",
           recordTitle: "Entry and resignation record",
           clickAdd: "Click add employee basic information...",
           workRecord: "Entry and resignation record",
           enterChooseTime: "Please select a time",
           tip: "Tips",
           cumulativeReward: "Cumulative reward",
           cumulativePunish: "Cumulative penalty",
           cumulativeLtter: "Received warning letter",
           Times: "Times",
           seal: "seal",
         },
         menuWrh: {
           reduceApproval: "reduce Approval",
           teleMarket: "Telemarketing",
           teleMarketRecord: "Telephone sales records",
         },
         tableWrh: {
           reduceType: "Type of reduction",
           applyPeople: "applicant",
           approvalResult: "Approval results",
           reduceResult: "Reduce result",
           approvalDetail: "Approval Details",
           reduceAmount: "Reduce amount",
           Operador: "Operador",
           dialTime: "Dial time",
           whentherDial: "whenther to dial",
           dialSituation: "Dial-up situation",
           remark: "Remarks",
         },
         formWrh: {
           birthDay: "birthDay",
           cardId: "Id number",
           cardCURP: "CURP",
           cardPhoto: "ID photo",
           staffNum: "employee ID",
           marryStatus: "marriage",
           chilNum: "the number of children at home",
           familyAddress: "home address",
           addressProof: "proof of residential address",
           familyContact: "person to contact",
           familyRealtion: "relationship",
           familyTelephone: "telephone number",
           companyName: "company name",
           companyPosition: "job title",
           companyTime: "production time",
           punishType: "rewards and punishments category",
           Type: "Type",
           punishMoney: "amount (MXN)",
           questionType: "types of punishment",
           punishDesc: "describe",
           //选择项label
           man: "male",
           woman: "female",
           onJob: "on the job",
           quit: "leave office",
           married: "married",
           unmarried: "divorced",
           single: "single",
           cohabitation: "live together",
           parent: "parents",
           couple: "couple",
           children: "sons and daughters",
           friend: "friend",
           reward: "reward",
           punish: "punishment",
           complianceIssues: "compliance issues",
           businessIssues: "business Issues",
           disciplinaryIssues: "discipline problems",
           oralWarning: "verbal warning",
           commitLetter: "undertaking",
           warningLetter: "warning letter",
           RFC: "RFC",
           personalInfo: "personal file",
           identityInfo: "identifiable information",
           familyInfo: "family background",
           workInfo: "work file",
           occupancyInfo: "work experience",
           rewardInfo: "rewards and punishment record",
           staffStatusInfo: "staff status",
           upload: "upload",
           status: "status",
           leaveTime: "leave time",
           enterTime: "starting Date",
           leaveReason: "leaving Reason",
         },
       };
